module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[50]293.7e26e4a.woff2";